import { useId, type ReactNode } from 'react';
import { Text } from '@gravity-ui/uikit';

/**
 * Поле формы: подпись над контролом, связанная с ним по `id`, подсказка и
 * ошибка под ним. Подпись снаружи, а не внутри контрола: её читает
 * скринридер и по ней находит поле автотест.
 */
export function Field({
  label,
  hint,
  error,
  required = false,
  children,
}: {
  label: string;
  hint?: ReactNode;
  error?: string | undefined;
  required?: boolean;
  children: (id: string) => ReactNode;
}) {
  const id = useId();
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="w-fit">
        <Text variant="subheader-1">
          {label}
          {required ? (
            <Text as="span" color="danger" aria-hidden="true">
              {' *'}
            </Text>
          ) : null}
        </Text>
      </label>
      {children(id)}
      {error === undefined ? null : (
        <Text variant="caption-2" color="danger" role="alert">
          {error}
        </Text>
      )}
      {hint === undefined || error !== undefined ? null : (
        <Text variant="caption-2" color="secondary">
          {hint}
        </Text>
      )}
    </div>
  );
}
